import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c3455c1a")

_pushScopeId("data-v-c3455c1a")
const _hoisted_1 = { class: "user-log" }
const _hoisted_2 = {
  key: 0,
  class: "section"
}
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "section__prefix" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-user-plus" }),
  /*#__PURE__*/_createVNode("span", null, "Criado por")
], -1)
const _hoisted_4 = { class: "section__user" }
const _hoisted_5 = {
  key: 1,
  class: "section"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "section__prefix" }, [
  /*#__PURE__*/_createVNode("i", { class: "pi pi-user-edit" }),
  /*#__PURE__*/_createVNode("span", null, "Modificado por")
], -1)
const _hoisted_7 = { class: "section__user" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.data.createdBy)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("span", _hoisted_4, _toDisplayString(_ctx.data.createdBy?.name), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.data.modifiedBy)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.data.modifiedBy?.name), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
})